<template>
    <div class="notice">
      <el-divider content-position="left">按条件搜索</el-divider>
      <el-row :gutter="20">
        <el-col :span="5" >
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">通知类型</span>
            <el-select
              v-model="tableConfig.type"
              clearable
              placeholder="请选择通知类型"
              style="width: 70%"
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">开始时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">结束时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="结束时间"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">状态</span>
            <el-select
              v-model="tableConfig.sendStatus"
              clearable
              placeholder="请选择状态"
              style="width: 70%"
            >
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <br />
      <el-divider content-position="left">功能按钮</el-divider>
      <el-row :gutter="20">
        <el-col :span="18" >
          <div class="grid-content">
            <el-button type="primary" @click="searchData">查 询</el-button>
            <el-button type="primary" @click="clearSearch">重 置</el-button>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="grid-content">
            <el-button type="primary" @click="openAdd">新 建</el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider content-position="left">通知列表</el-divider><br />
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 100%"
        border
      >
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="content" label="通知内容"></el-table-column>
        <el-table-column prop="typeName" label="通知类型" width="140"></el-table-column>
        <el-table-column prop="sendTime" label="发送时间" width="180"></el-table-column>
        <el-table-column prop="sendStatusName" label="发送状态" width="180"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)" v-if="scope.row.sendStatusName === '待发送'">编辑</el-button>
            <el-button type="text" size="small" @click="cancel(scope.row.id)" v-if="scope.row.sendStatusName === '已发送'">撤回</el-button>
            <el-button type="text" size="small" @click="deleteNotice(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-count="tableConfig.size"
          :page-sizes="[10, 20, 30, 50,100]"
          :page-size="10"
          :current-page="tableConfig.index"
          :total="total"
        ></el-pagination>
      </footer>
      <el-dialog
        :title="dialogType + '通知'"
        :visible.sync="dialogVisible"
        width="40%"
        center
        :before-close="handleClose"
      >
        <el-form
          :model="editForm"
          :rules="rules"
          ref="editForm"
          label-width="100px"
        >
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="editForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="通知内容" prop="content">
            <el-input
              v-model="editForm.content"
              placeholder="请输入通知内容"
              type="textarea"
            ></el-input>
          </el-form-item>

          <el-form-item label="通知类型" prop="">
            <el-select
              v-model="editForm.type"
              clearable
              placeholder="请选择类型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="通知时间">
            <el-radio-group v-model="editForm.sendType">
              <el-radio :label="1">立即发送</el-radio>
              <el-radio :label="0">延迟发送</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="发送时间" v-if="editForm.sendType === 0">
            <el-date-picker
              style="width: 100%"
              v-model="editForm.sendTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="发送时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitNotice">保 存</el-button>
          <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import _ from 'lodash'
  export default {
    name: "NoticeManage",
    data() {
      return {
        dialogVisible: false, // 查看 弹框显示
        dialogType: '新增',
        rules: {}, // 验证信息
        initEditForm: {
          content: '',
          sendStatus: '',
          sendTime: '',
          type: '',
          title: '',
          sendType: ''
        },
        editForm: {
        }, // 表单
        tableData: [], // 列表
        total: 0, // 总数量
        tableConfig: {
          size: 10, // 每页数量
          index: 1, // 当前页码
          type: '',
          startTime: '',
          endTime: '',
          sendStatus: ''
        },
        tableLoading: false,
        typeList: [],
        statusList: [
          {
            value: 1,
            label: '已发送'
          },{
            value: 0,
            label: '待发送'
          }]
      };
    },
    computed: {
    },
    mounted() {
      this.getTypeList();
      this.getData();
    },
    methods: {
      searchData() {
        this.tableConfig.index = 1;
        this.getData();
      },
      async getData() {
        // 获取列表
        this.tableLoading = true;
        let res = await this.$api.public_api.listNotice(this.tableConfig);
        if (res) {
          this.tableData = res.listNotice.list || [];
          this.total = res.listNotice.total;
        }
        this.tableLoading = false;
      },
      async getTypeList() {
        let res = await this.$api.public_api.getNoticeType();
        if (res) {
          this.typeList = res.listNoticeType;
        }
      },
      DateFormatter({updateDatetime = ""}) {
        // 格式化时间
        if (updateDatetime) return new Date(updateDatetime).toDate();
        return "";
      },
      currentChange(index) {
        // 分页
        this.tableConfig.index = index;
        this.getData();
      },
      sizeChange(size) {
        this.tableConfig.size = size;
        this.getData();
      },
      clearSearch() {
        // 清空搜索数据
        this.tableConfig = {
          ...this.tableConfig,
          type: "", //
          startTime: "", //
          endTime: "", //
          sendStatus: "", // 状态
        };
      },
      handleClose(done) {
        // 弹框关闭
        this.$confirm("确认关闭？")
          .then(_ => {

            done();
          })
          .catch(_ => {
          });
      },
      openEdit(row) {
        this.dialogVisible = true;
        this.dialogType = '编辑'
        this.getNotice(row.id)
      },
      openAdd() {
        this.dialogVisible = true;
        this.dialogType = '新增'
        this.editForm = _.cloneDeep(this.initEditForm)
      },
      async getNotice(id) {
        let res = await this.$api.public_api.getNotice(id);
        if (res) {
          this.editForm = _.cloneDeep(res.getNotice)
        }
      },
      async deleteNotice(id) {
        await this.$confirm('确定删除该通知吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.public_api.delNotice( id).then((response) => {
            if (response) {
              this.getData()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
      },


      async cancel(id){
        await this.$confirm('确定撤回该通知吗?', '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.public_api.cancelNotice(id).
          then((response) => {
            if (response) {
              this.getData()
              this.$message({
                type: 'success',
                message: '撤回成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      },

      async submitNotice() {
        let url
        if (this.dialogType === '新增') {
          url = 'message/insertNotice'
        } else if (this.dialogType === '编辑') {
          url = 'message/updNotice'
        }
        let res = await this.$axios.post(this.$api.public_api.base+url, this.editForm);
        if (res) {
          this.$message.success('操作成功！')
          this.dialogVisible = false;
          this.searchData();
        }
      },

    }
  };
  </script>
  <style lang="scss" scoped>
  .notice{
    padding: 20px 10px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    input[type=file]{
      display: none;
    }
    .label{
      display: inline-block;
      width: 70px;
    }
    footer{
      padding-top: 20px;
      text-align: right;
    }
    .el-form{
      .el-select{
        width: 100%
      }
    }

    .bg-alex1{
      background: #d3dce6
    }
  }
  </style>



// WEBPACK FOOTER //
// src/pages/interaction/message-push1.vue